import type { Plugin, App, Component } from 'vue'

// 绑定install,使得可以app.use注册为全局组件
type SFCWithInstall<T> = T & Plugin
export function withInstall<T extends Component>(comp: T) {
  ;(comp as SFCWithInstall<T>).install = (app: App) => {
    app.component((comp as { name: string }).name, comp)
  }
  return comp as SFCWithInstall<T>
}
